import { TriggeringEventsStatuses, type TTriggeringEventsStatus } from '@inpart-io/padme-iap';

export const COLOR_ACCENTS = {
    BLUE: { label: 'Blue', value: '#7dbeff', color: 'blue', lightColor: 'blue-light' },
    BROWN: { label: 'Brown', value: '#b48b7d', color: 'brown', lightColor: 'brown-light' },
    CYAN: { label: 'Cyan', value: '#70e0e5', color: 'cyan', lightColor: 'cyan-light' },
    GREEN: { label: 'Green', value: '#73E5AC', color: 'green', lightColor: 'green-light' },
    ORANGE: { label: 'Orange', value: '#ffae70', color: 'orange', lightColor: 'orange-light' },
    PINK: { label: 'Pink', value: '#f76f8e', color: 'pink', lightColor: 'pink-light' },
    PURPLE: { label: 'Purple', value: '#8082ff', color: 'purple', lightColor: 'purple-light' },
    RED: { label: 'Red', value: '#ff8480', color: 'red', lightColor: 'red-light' },
    YELLOW: { label: 'Yellow', value: '#eae47b', color: 'yellow', lightColor: 'yellow-light' }
};

export enum LeadStatusColorEnum {
    DRAFT = '#8587ff',
    ACTIVE = '#8587ff',
    TRIAGE = '#8587ff',
    DISQUALIFIED = '#ff758e',
    CLOSED = '#02c39a',
    QUALIFIED = '#02c39a',
    ON_HOLD = '#c4d6f8'
}

export enum CampaignStatusColorEnum {
    DRAFT = '#c4d6f8',
    ONGOING = '#8587ff',
    CLOSED = '#ff758e'
}

export enum AgreementStatusColorEnum {
    DRAFT = '#c4d6f8',
    ABORTED = '#324467',
    ACTIVE = '#8587ff',
    TERMINATED = '#324467',
    EXPIRED = '#ff758e'
}

export enum AllianceStatusColorEnum {
    DRAFT = '#c4d6f8',
    ABORTED = '#324467',
    ACTIVE = '#8587ff',
    TERMINATED = '#324467'
}

export enum TriggeringEventsStatusColorEnum {
    ON_TRACK = '#8587ff',
    OFF_TRACK = '#ff9f1c',
    FAILED = '#f44336',
    SUCCESSFUL = '#02c39a',
    TERMINATED = '#324467'
}

export const TriggeringEventsStatusesColors = new Map<TTriggeringEventsStatus, string>([
    [TriggeringEventsStatuses.ON_TRACK, TriggeringEventsStatusColorEnum.ON_TRACK],
    [TriggeringEventsStatuses.OFF_TRACK, TriggeringEventsStatusColorEnum.OFF_TRACK],
    [TriggeringEventsStatuses.SUCCESSFUL, TriggeringEventsStatusColorEnum.SUCCESSFUL],
    [TriggeringEventsStatuses.FAILED, TriggeringEventsStatusColorEnum.FAILED],
    [TriggeringEventsStatuses.TERMINATED, TriggeringEventsStatusColorEnum.TERMINATED]
]);

export const COLOR_OPTIONS = {
    DEFAULT: [
        {
            label: COLOR_ACCENTS.BLUE.label,
            value: COLOR_ACCENTS.BLUE.value,
            color: COLOR_ACCENTS.BLUE.color,
            lightColor: COLOR_ACCENTS.BLUE.lightColor,
            oldValue: ['#00bcd4', '#85b6ff'],
            oldColor: ['cyan']
        },
        {
            label: COLOR_ACCENTS.BROWN.label,
            value: COLOR_ACCENTS.BROWN.value,
            color: COLOR_ACCENTS.BROWN.color,
            lightColor: COLOR_ACCENTS.BROWN.lightColor,
            oldValue: ['#ce9e95']
        },
        {
            label: COLOR_ACCENTS.CYAN.label,
            value: COLOR_ACCENTS.CYAN.value,
            color: COLOR_ACCENTS.CYAN.color,
            lightColor: COLOR_ACCENTS.CYAN.lightColor,
            oldValue: ['#9dedff']
        },
        {
            label: COLOR_ACCENTS.GREEN.label,
            value: COLOR_ACCENTS.GREEN.value,
            color: COLOR_ACCENTS.GREEN.color,
            lightColor: COLOR_ACCENTS.GREEN,
            oldValue: ['#4caf50', '#33d29c', '#56caca', '#3fc380']
        },
        {
            label: COLOR_ACCENTS.ORANGE.label,
            value: COLOR_ACCENTS.ORANGE.value,
            color: COLOR_ACCENTS.ORANGE.color,
            lightColor: COLOR_ACCENTS.ORANGE,
            oldValue: ['#ff9800', '#ffb195']
        },
        {
            label: COLOR_ACCENTS.PINK.label,
            value: COLOR_ACCENTS.PINK.value,
            color: COLOR_ACCENTS.PINK.color,
            lightColor: COLOR_ACCENTS.PINK.lightColor,
            oldValue: ['#d094d1']
        },
        {
            label: COLOR_ACCENTS.PURPLE.label,
            value: COLOR_ACCENTS.PURPLE.value,
            color: COLOR_ACCENTS.PURPLE.color,
            lightColor: COLOR_ACCENTS.PURPLE.lightColor,
            oldValue: ['#9c27b0', '#7e6ab6']
        },
        {
            label: COLOR_ACCENTS.RED.label,
            value: COLOR_ACCENTS.RED.value,
            color: COLOR_ACCENTS.RED.color,
            lightColor: COLOR_ACCENTS.RED.lightColor,
            oldValue: ['#f44336', '#eb8190']
        },
        {
            label: COLOR_ACCENTS.YELLOW.label,
            value: COLOR_ACCENTS.YELLOW.value,
            color: COLOR_ACCENTS.YELLOW.color,
            lightColor: COLOR_ACCENTS.YELLOW.lightColor,
            oldValue: ['#fdd835', '#ffc46c'],
            oldColor: ['yellow-7']
        }
    ] as IColor[],
    TAG: [
        {
            label: COLOR_ACCENTS.BLUE.label,
            value: COLOR_ACCENTS.BLUE.value,
            color: COLOR_ACCENTS.BLUE.color,
            oldValue: ['#008acb', '#85b6ff']
        },
        {
            label: COLOR_ACCENTS.GREEN.label,
            value: COLOR_ACCENTS.GREEN.value,
            color: COLOR_ACCENTS.GREEN.color,
            oldValue: ['#4caf50', '#33d29c', '#56caca', '#3fc380']
        },
        {
            label: COLOR_ACCENTS.ORANGE.label,
            color: COLOR_ACCENTS.ORANGE.color,
            value: COLOR_ACCENTS.ORANGE.value,
            oldValue: ['#f29100', '#ffb195']
        },
        {
            label: COLOR_ACCENTS.PURPLE.label,
            value: COLOR_ACCENTS.PURPLE.value,
            color: COLOR_ACCENTS.PURPLE.color,
            oldValue: ['#9f3abc', '#7e6ab6']
        },
        {
            label: COLOR_ACCENTS.RED.label,
            value: COLOR_ACCENTS.RED.value,
            color: COLOR_ACCENTS.RED.color,
            oldValue: ['#e25a64', '#eb8190']
        }
    ] as IColor[]
};

export const DEFAULT_BRIEF_COLOR = COLOR_OPTIONS.DEFAULT[0];

export interface IColor {
    label: string;
    value: string;
    color: string;
    lightColor?: string;
    oldColor?: string[];
    oldValue?: string[];
}
